import { FC, HTMLAttributes, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, DatePicker, Flex, Input } from 'antd';

import ExportIcon from 'assets/images/icons/export.svg?react';
import FiltersIcon from 'assets/images/icons/filters.svg?react';
import { TransactionFilterDrawer } from 'entities/Transaction';
import { useFilters } from 'features/Filters';
import { EFilters } from 'features/Filters/model/enums';
import { TRANSACTION_STATUSES_OPTIONS } from 'shared/consts';
import { useMedia } from 'shared/hooks';
import { CheckableTag } from 'shared/ui';

import { useDateFilters } from '../../hooks/useDateFilters';

import styles from './TransactionsFilters.module.scss';

const { Search } = Input;

interface ITransactionsFiltersProps extends HTMLAttributes<HTMLDivElement> {}

export const TransactionsFilters: FC<ITransactionsFiltersProps> = ({ ...props }) => {
	const { t } = useTranslation();
	const isMobile = useMedia();
	const isDesktop = useMedia('desktop');
	const { dateRange, onDateChange } = useDateFilters(EFilters.DATE_FROM, EFilters.DATE_TO);
	const { onFilterChange, selectedTags, onTagsChange } = useFilters();
	const [isTransactionFilterDrawerOpen, setIsTransactionFilterDrawerOpen] = useState(false);

	const exportURL = '#';
	return (
		<>
			<Flex
				{...props}
				justify="space-between"
				align={isDesktop ? 'center' : 'flex-start'}
				vertical={isMobile}
				style={{ flexWrap: 'wrap' }}
				gap={'8px 0'}>
				<Flex gap={8} align="center" style={{ flexWrap: 'wrap' }}>
					<Search
						placeholder="Search"
						style={{ width: isMobile ? '250px' : '200px' }}
						onChange={(e) => onFilterChange(EFilters.SEARCH, e.target.value)}
					/>
					{isMobile && (
						<Button href={exportURL} download icon={<ExportIcon />} iconPlacement={'end'}>
							{t('Export')}
						</Button>
					)}
					<DatePicker.RangePicker
						style={{ width: isMobile ? '100%' : 'auto' }}
						value={dateRange}
						onChange={onDateChange}
						format="YYYY-MM-DD"
					/>
					<Button
						icon={<FiltersIcon />}
						iconPlacement={'end'}
						onClick={() => setIsTransactionFilterDrawerOpen(true)}
						// block={isMobile}>
					>
						{t('Filters')}
					</Button>
					{TRANSACTION_STATUSES_OPTIONS.map((tag) => (
						<CheckableTag
							className={styles.tag}
							tag={tag}
							key={tag.value}
							checked={selectedTags.includes(tag.value)}
							onTagsChange={() => onTagsChange(EFilters.STATUS, tag.value)}
						/>
					))}
				</Flex>
				{!isMobile && (
					<Button href={exportURL} download icon={<ExportIcon />} iconPlacement={'end'}>
						{t('Export')}
					</Button>
				)}
			</Flex>
			<TransactionFilterDrawer
				open={isTransactionFilterDrawerOpen}
				onClose={() => setIsTransactionFilterDrawerOpen(false)}
			/>
		</>
	);
};
